const Home = () => {
    return <span></span>;
};

export default Home;
